var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.0022C10.4141 2.00236 10.75 2.33808 10.75 2.7522V9.25024H17.2471C17.6613 9.25024 17.9971 9.58603 17.9971 10.0002C17.9969 10.4143 17.6612 10.7502 17.2471 10.7502H10.75V17.2473C10.75 17.6614 10.4141 17.9972 10 17.9973C9.58579 17.9973 9.25 17.6615 9.25 17.2473V10.7502H2.75195C2.33785 10.7502 2.00213 10.4143 2.00195 10.0002C2.00195 9.58603 2.33774 9.25024 2.75195 9.25024H9.25V2.7522C9.25 2.33798 9.58579 2.0022 10 2.0022Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.41454f38.svg";
export { ForwardRef as ReactComponent };